import { useEffect, useState } from "react";

export const LAUNCH_DATE = new Date("2026-11-01T00:00:00Z");
export const ACCESSIBILITY_DATE = new Date("2027-01-01T00:00:00Z");

const KEY = "wylo_launch_popup_dismissed";
const EVT = "wylo-launch-dismissed";

export function isLaunchDismissed() {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function markLaunchDismissed() {
  try {
    localStorage.setItem(KEY, "1");
  } catch {}
  window.dispatchEvent(new Event(EVT));
}

export function useLaunchDismissed() {
  const [dismissed, setDismissed] = useState(isLaunchDismissed);
  useEffect(() => {
    const h = () => setDismissed(true);
    window.addEventListener(EVT, h);
    return () => window.removeEventListener(EVT, h);
  }, []);
  return dismissed;
}

export function useCountdown(target) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const diff = Math.max(0, target - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds, elapsed: diff === 0 };
}

export const pad = (n) => String(n).padStart(2, "0");
